// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyDqQTs0xRawrU9loasIdSIy0ANslpVMzzQ",
    authDomain: "monite-application.firebaseapp.com",
    projectId: "monite-application",
    storageBucket: "monite-application.appspot.com",
    messagingSenderId: "1058390694070",
    appId: "1:1058390694070:web:56099b94d8e4be53f36e17",
    measurementId: "G-513WSYXTE3"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

let analyticsInstance = null;
let analyticsInitPromise = null;

export function ensureAnalytics() {
  if (analyticsInstance) return Promise.resolve(analyticsInstance);
  if (analyticsInitPromise) return analyticsInitPromise;
  analyticsInitPromise = isSupported().then((ok) => {
    if (!ok) return null;
    analyticsInstance = getAnalytics(app);
    return analyticsInstance;
  }).catch(() => null);
  return analyticsInitPromise;
}

export function getGa() {
  return analyticsInstance;
}

export default app; 